import RadioCardListPage from "@components/RadioCardListPage"
import { isHomeDesignFlow } from "@helpers/localStorage"

const OPTIONS = [
  { emoji: "😎", key: "confident" },
  { emoji: "😊", key: "friendly" },
  { emoji: "💼", key: "professional" },
  { emoji: "🎨", key: "creative" },
  { emoji: "✨", key: "authentic" },
]

const HOME_OPTIONS = [
  { emoji: "🤗", key: "warmInviting" },
  { emoji: "🧘", key: "calmRelaxing" },
  { emoji: "🔥", key: "boldDramatic" },
  { emoji: "🌿", key: "freshNatural" },
  { emoji: "💎", key: "sophisticatedPolished" },
]

export default function FirstImpressionPage() {
  if (isHomeDesignFlow()) {
    return (
      <RadioCardListPage
        translationKey="firstImpressionHomeDesign"
        options={HOME_OPTIONS}
        subtitle="subtitle"
      />
    )
  }
  return (
    <RadioCardListPage
      translationKey="firstImpression"
      options={OPTIONS}
      subtitle="subtitle"
    />
  )
}
